// extracted by mini-css-extract-plugin
export var fullScreenModal = "_redotech-redo-customer-portal-app-lib-portal-four-shared-components-portal-modal-full-screen-modal";
export var modal = "_redotech-redo-customer-portal-app-lib-portal-four-shared-components-portal-modal-modal";